module.exports = __webpack_public_path__ + "img/2_a-title.817b33c0.gif";